import React from 'react';
import { createPortal } from 'react-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import ContentView from 'components/Pages/ContentView/ContentView.jsx';
import FadeIn from '@bit/knotchinc.web-react-components.fade-in';
import {
  ModalContainer,
  ModalBackdrop,
  ContentPopupContainer,
  ContentPopup,
  CloseButton,
  ContentScreenshotContainer,
  ContentScreenshotImg,
  ContentScreenshotModal,
  EyeIcon,
  ModalButtons,
  // ShareModalButton,
  ViewModalButton,
  BookmarkModalButton,
} from './styled.js';

const modalRoot = document.getElementById('contentModalContainer');

class ContentModal extends React.Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
    this.state = {
      open: false,
      active: false,
      withTransition: true,
      showContent: false,
      showBackdrop: false,
      isScreenshotContainerOpen: false,
      isScreenshotShown: false,
      pageScreenshotUrl: '',
    };

    this.container = null;
    this.popup = null;
  }

  componentDidMount() {
    modalRoot && modalRoot.appendChild(this.el);
    this.openPopup();
  }

  componentWillUnmount() {
    modalRoot && modalRoot.removeChild(this.el);
  }

  openPopup() {
    const { active, open } = this.state;
    const { dimensions } = this.props;

    if (active || open) {
      return;
    }

    // need to reset
    this.popup.style.left = `${dimensions.left}px`;
    this.popup.style.top = `${dimensions.top}px`;
    this.popup.style.width = `${dimensions.width}px`;
    this.popup.style.height = `${dimensions.height}px`;

    setTimeout(() => {
      this.setState({ open: true, withTransition: true });
    }, 25);

    setTimeout(() => {
      this.setState({ showContent: true });
    }, 500);

    setTimeout(() => {
      this.setState({ showBackdrop: true });
    }, 100);
  }

  closePopup() {
    const { open } = this.state;

    if (!open) {
      return;
    }

    this.setState({ showContent: false });

    setTimeout(() => {
      this.setState({ showBackdrop: false });
    }, 20);

    setTimeout(() => {
      this.setState({ open: false });
    }, 70);

    setTimeout(() => {
      this.props.close();
    }, 400);
  }
  openScreenshot(url) {
    this.setState({ isScreenshotContainerOpen: true, pageScreenshotUrl: url });

    setTimeout(() => {
      this.setState({ isScreenshotShown: true });
    }, 50);
  }

  closeScreenshot() {
    const { isScreenshotContainerOpen, isScreenshotShown } = this.state;

    if (isScreenshotContainerOpen && isScreenshotShown) {
      this.setState({ isScreenshotShown: false });

      setTimeout(() => {
        this.setState({ isScreenshotContainerOpen: false });
      }, 300);
    }
  }

  toggleBookmark() {
    const { setLocalBookmark, bookmarked } = this.props;
    setLocalBookmark(!bookmarked);
  }

  render() {
    const { isOpen, data, setLocalBookmark, bookmarked } = this.props;
    const { showContent, active, open, withTransition, showBackdrop, isScreenshotShown, isScreenshotContainerOpen, pageScreenshotUrl } = this.state;

    return createPortal(
      <ModalContainer isOpen={isOpen}>
        <ModalBackdrop visible={showBackdrop} onClick={() => this.closePopup()} />
        <ContentPopupContainer
          isOpen={open}
          withTransition={withTransition}
          active={active}
          ref={(el) => { this.popup = el; }}
        >
          <ModalButtons>
            {/* <ShareModalButton /> */}
            {data.page_url && <ViewModalButton as="a" target="_blank" href={data.page_url} />}
            <BookmarkModalButton active={bookmarked} onClick={() => this.toggleBookmark()} />
          </ModalButtons>
          <CloseButton onClick={() => this.closePopup()}>×</CloseButton>
          <ContentPopup open={open}>
            <PerfectScrollbar>
              <FadeIn leave={100}>
                {showContent &&
                  <ContentView
                    id={data.public_id}
                    data={data}
                    openScreenshot={(url) => this.openScreenshot(url)}
                    setLocalBookmark={setLocalBookmark}
                    localBookmarked={bookmarked}
                    closePopup={() => this.closePopup()}
                  />}
              </FadeIn>
            </PerfectScrollbar>
          </ContentPopup>
        </ContentPopupContainer>
        <ContentScreenshotContainer isOpen={isScreenshotContainerOpen} onClick={() => this.closeScreenshot()} >
          <ContentScreenshotModal isOpen={isScreenshotShown} >
            <PerfectScrollbar>
              <ContentScreenshotImg src={pageScreenshotUrl || data.page_screenshot_url} />
            </PerfectScrollbar>
            <EyeIcon onClick={() => this.closeScreenshot()} />
          </ContentScreenshotModal>
        </ContentScreenshotContainer>
      </ModalContainer>,
      this.el,
    );
  }
}

export default ContentModal;
